module.exports = __webpack_public_path__ + "3f16e137/img/scraper-icon.df6ccde5.svg";